// Where a phone's labels print (2026-10-29, phone Shipping): the shop print queue station that has an agent.
// jobq-api GET /features `mobile.label_station` names it ('laser' until the shipping Pi runs a print agent, then
// 'shipping'); anything else, a failed read or an older API reads as 'laser', the station that always has one
// (docs/mobile-pwa-plan.md "Print audit"). The desktop opens PDFs and never asks.
import { useEffect, useState } from 'react';
import { fetchFeaturesBody } from '../shippingHub/hubFlag';

export const LABEL_STATIONS = Object.freeze({
  laser: Object.freeze({ id: 'laser', printer: 'Laser Zebra', pi: 'laser Pi' }),
  shipping: Object.freeze({ id: 'shipping', printer: 'Shipping Zebra', pi: 'shipping Pi' }),
});

/** A station id -> its printer words ({id, printer, pi}); an unknown or missing id is the laser. */
export function labelStation(id) {
  return LABEL_STATIONS[id] || LABEL_STATIONS.laser;
}

/** GET /features body -> the phone's label station id ('laser' unless the API names a known one). */
export function parseLabelStation(body) {
  const m = body && typeof body === 'object' && !Array.isArray(body) ? body.mobile : null;
  const id = m && typeof m === 'object' ? m.label_station : null;
  return LABEL_STATIONS[id] ? id : 'laser';
}

/** The phone's label station id: 'laser' until GET /features answers. */
export function useLabelStation() {
  const [id, setId] = useState('laser');
  useEffect(() => {
    let alive = true;
    fetchFeaturesBody().then((body) => { if (alive) setId(parseLabelStation(body)); });
    return () => { alive = false; };
  }, []);
  return id;
}
